import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import Waypoint from 'react-waypoint';
import * as types from '../../../constants/ActionTypes';

import AssessmentForm from '../../therapist/AssessmentForm'
import PatientSessions from '../../therapist/PatientSessions'
import PatientDetailsForm from '../../admin/PatientDetailsForm'
import ShowCategories from '../../ui/ShowCategories'
import CategoryAreas from '../../ui/CategoryAreas'
import Sidenav from '../../sidenav/Sidenav';
import MoreVerticalSVG from '../../ui/images/MoreVerticalSVG'
import DocumentUpload from '../../ui/DocumentUpload'
import FileImg from '../../../images/icons/FileIcon'
import Avatar from '../../user/Avatar'
import AssessmentComponent from './AssessmentComponent'
import SessionComponent from './SessionComponent'

import { listenToUserSessionNotifications, unListenToUserSessionNotifications } from '../../../actions/comments'
import {
	fetchSessions,
	// deleteSession,
	// saveSession,
	fetchTherapistPatients,
	// fetchAllTherapistPatientRecord,
	// createAssessment,
	// fetchPatientAssessments,
	// savePatient,
	// setPractice,
	// archiveTherapistPatient,
	// unarchiveTherapistPatient,
	// deleteTherapistPatient
} from '../../../actions/therapist'
import {
	fetchAllPatientRecords,
	fetchPatientAssessments
} from '../../../actions/patient'
import { setTitle, fetchTherapyAreas, fetchVideos, setModal } from "../../../actions/index"
import { deleteDocument } from '../../../actions/documents'
import moment from 'moment'

import loaderImg from '../../practice_admin/images/loader.gif'

import deleteSVG from '../../therapist/images/trash.svg'
import archiveSVG from '../../therapist/images/archive.svg'
import unArchiveSVG from '../../therapist/images/archive-open.svg'

let cleanNewAssessment = {
	'therapy_areas': [],
	'documents': []
}

let cleanNewSession = {
	'therapy_areas': [],
	'videos': [],
	'created': new Date()
}

@connect((store) => {
	return {
		User: store.User.User,
		app: store.app,
		therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
		patients: store.patients,
		patient_records: store.patient_records,
		assessments: store.assessments,
		videos: store.videos,
		patient_sessions: store.patient_sessions,
		sessions: store.sessions,
		modal: store.modal,
		notifications: store.notifications
	}
})
class PatientViewDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			'patient': {},
			'patientForm': {},
			'patientRecord': {},
			'newAssessment': { ...cleanNewAssessment },
			'gotPatients': false,
			'newAssessmentFormOpen': false,
			'editPatientOpen': false,
			'newSessionFormOpen': false,
			'newSessionSelectTherapyAreasOpen': false,
			'newSessionSelectVideosOpen': false,
			'newSession': { ...cleanNewSession },
			'patient_sessions_array': [],
			'patient_assessments_array': [],
			'whichSession': 'state',
			'showAssessment': false,
			'from': props.location.query.from || 0,
			'loading': true,
			'noMoreSessions': false,
			'blur': false,
			'startDate': moment(),
			'assessmentStartDate': moment(),
			'filterBy': 'all',
			'filterDate': null,
			'homework': null,
			'newSessionAssessmentMenu': false,
			'currenetAssessment': null
		}
		// this.assignAssessmentTherapyArea = this.assignAssessmentTherapyArea.bind(this)
		this.getPatient = this.getPatient.bind(this)
		// this.archivePatient = this.archivePatient.bind(this)
		// this.deletePatient = this.deletePatient.bind(this)
		// this.savePatient = this.savePatient.bind(this)
		// this.setPractice = this.setPractice.bind(this)
		this.getPatientRecord = this.getPatientRecord.bind(this)
		this.showMenu = this.showMenu.bind(this)
		// this.createAssessment = this.createAssessment.bind(this)
		// this.showNewAssessmentForm = this.showNewAssessmentForm.bind(this)
		// this.handleAssessmentFormChange = this.handleAssessmentFormChange.bind(this)
		this.handlePatientImage = this.handlePatientImage.bind(this)
		// this.toggleSelectedSessionVideo = this.toggleSelectedSessionVideo.bind(this)
		// this.handleSessionFormChange = this.handleSessionFormChange.bind(this)
		this.toggle = this.toggle.bind(this)
		this.setup = this.setup.bind(this)
		this.showLatestAssessmentDetails = this.showLatestAssessmentDetails.bind(this)
		this.latestAssessment = this.latestAssessment.bind(this)
		this.getPatientAssessments = this.getPatientAssessments.bind(this)
		// this.assignSessionTherapyArea = this.assignSessionTherapyArea.bind(this)
		// this.assignTherapyArea = this.assignTherapyArea.bind(this)
		// this.saveSession = this.saveSession.bind(this)
		// this.sendSession = this.sendSession.bind(this)
		// this.clearSession = this.clearSession.bind(this)
		this.showNewSessionForm = this.showNewSessionForm.bind(this)
		this.sessionSelectedTherapyArea = this.sessionSelectedTherapyArea.bind(this)
		this.sessionSelectedTherapyAreaVideos = this.sessionSelectedTherapyAreaVideos.bind(this)
		this.showEditSession = this.showEditSession.bind(this)
		this.setSessionsArray = this.setSessionsArray.bind(this)
		this.setAssessmentArray = this.setAssessmentArray.bind(this)
		this.setUpNewSession = this.setUpNewSession.bind(this)
		this.sessionClick = this.sessionClick.bind(this)
		this.handlePatientInputChange = this.handlePatientInputChange.bind(this)
		this.attachSessionImage = this.attachSessionImage.bind(this)
		// this.attachSessionInternalImage = this.attachSessionInternalImage.bind(this)
		// this.removeSessionInternalImage = this.removeSessionInternalImage.bind(this)
		// this.removeSessionImage = this.removeSessionImage.bind(this)
		// this.removeSessionImageFromSent = this.removeSessionImageFromSent.bind(this);
		// this.removeSessionInternalImageFromSent = this.removeSessionInternalImageFromSent.bind(this)
		// this.deleteSession = this.deleteSession.bind(this)
		// this.assessmentCategoryClick = this.assessmentCategoryClick.bind(this)
		this._renderWaypoint = this._renderWaypoint.bind(this)
		// this.fetchMoreSessions = this.fetchMoreSessions.bind(this)
		this.blur = this.blur.bind(this)
		// this.isEditable = this.isEditable.bind(this)
		// this.addAssessmentDocument = this.addAssessmentDocument.bind(this)
		// this.deleteAssessmentDocument = this.deleteAssessmentDocument.bind(this)
		// this.handleChange = this.handleChange.bind(this)
		// this.handleAssessmentDOAChange = this.handleAssessmentDOAChange.bind(this)
		this.getAssessmentsSessionsArray = this.getAssessmentsSessionsArray.bind(this)
		this.showAssessment = this.showAssessment.bind(this)
		this.filterBy = this.filterBy.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
		this.toggleHomework = this.toggleHomework.bind(this)
		this.toggleNewSessionAssessmentMenu = this.toggleNewSessionAssessmentMenu.bind(this)
		this.toggleShowAssessment = this.toggleShowAssessment.bind(this)
	}

	handleChange(date) {
		this.setState({
			'patientForm': { ...this.state.patientForm, ['dob']: date }
		});
		this.setState({
			startDate: date
		});
	}

	componentDidUpdate(nextProps, nextState) {
		if (
			(nextProps.params.patientId !== this.props.params.patientId) ||
			(nextProps.app.authed !== this.props.app.authed)
		) {
			this.setState({
				gotPatients: false
			});
		}
		// console.log('User',this.props.User);
		if (this.props.User.name != nextProps.User.name) {
			console.log('Update');
			this.setup()
		}
	}

	shouldComponentUpdate(nextProps) {
		const { modal, notifications } = this.props;

		// Only update this is the modal is not open or if the notifications have changed
		if (modal && modal.isOpen && nextProps.notifications !== notifications) {
			return false
		} else {
			return true
		}
	}

	componentWillUnmount() {
		let { User } = this.props
		unListenToUserSessionNotifications(User.uid)
		if (this.imageTimeout) {
			clearTimeout(this.imageTimeout)
		}
	}

	isEditable() {
		const { params, User } = this.props;
		// return params.therapistId === User._id || !params.therapistId
		return false
	}

	handleAssessmentDOAChange(date) {
		this.setState({
			'newAssessment': { ...this.state.newAssessment, ['doa']: date }
		});
		this.setState({
			assessmentStartDate: date
		});
		// console.log(date);
	}

	handleAssessmentFormChange(e, key) {
		const { patient } = this.state;
		console.log(e.target);
		let val = e.target.value
		// date of assessment can't be earlier than birth
		if (key === 'doa' && patient.dob && !moment(val).isAfter(patient.dob)) {
			// val = moment(patient.dob).format('YYYY-MM-DD')
			val = moment(patient.dob)
		}
		this.setState({
			'newAssessment': { ...this.state.newAssessment, [key]: val }
		});
	}



	componentDidMount() {
		this.props.dispatch(setTitle('Therapist'))
		this.props.dispatch(fetchTherapyAreas())
		this.props.dispatch(fetchVideos())
		this.setup()
	}

	setup() {
		const { dispatch, User, params } = this.props
		const { from } = this.state
		const self = this;

		if (User.therapist || User.Owner) {
			// only this therapist or the owner of this practice can go further
			if (!User.therapist && !params.therapistId) {
				alert('Only a therapist can view this page')
				return
			}
			if (params.therapistId && !User.therapist && !User.Owner) {
				alert('Only a therapist or owner can view this page')
				return
			}
			if (!User.therapist && User.Owner && User.ownPractices.find(p => p._id === params.practiceId)) {
				alert('You need to be the owner of this practice to view this page')
				return
			}
			this.setState({
				'patientForm': {},
				'patient': {}
			})
			this.getPatient()
			this.setPractice()
			this.getPatientRecord()
				.then(records => {
					if (records.length) {
						records.forEach(function(record, index) {
							if (record._id) {
								// self.setState({ 'loading': true })

								dispatch(listenToUserSessionNotifications(User.uid))
								dispatch(fetchSessions(record._id, from))
									.then(sessions => {
										self.setSessionsArray()
										if ((records.length-1) === index) {
											self.setState({ 'loading': false });
										}
									})
							} 
						});
					} else {
						alert('No assessments found')
						this.setState({ 'loading': false })
					}
				})
		}
	}

	getPatientRecord() {
		const { params } = this.props
		const { patientId } = params;
		const self = this;

		return this.props.dispatch(fetchAllPatientRecords(patientId))
			.then(patientRecords => {
				if (patientRecords.length) {
					patientRecords.forEach(function (patientRecord, index) {
						if (patientRecord._id) {
							self.getPatientAssessments(patientRecord._id)
						}
					});
				}
				this.setState({
					'patientRecord': patientRecords
				});
				return patientRecords;
			})
	}

	getPatientAssessments(patientRecordId) {
		let therapistId = this.props.User._id;
		this.props.dispatch(fetchPatientAssessments(therapistId, patientRecordId))
			.then(d => {
				this.setAssessmentArray();
				// set new session therapy areas
				this.setState({
					//'newSession': {...this.state.newSession, therapy_areas: latestAssessment.therapy_areas}
					'newSession': { ...this.state.newSession, therapy_areas: [] }
				})
			});
	}


	insertSessionUsers(sessionId) {
		let { dispatch, User } = this.props;
		let { patient } = this.state;
		let uids = [];

		uids.push(User.uid);

		patient.guardians.forEach(u => {
			uids.push(u.uid)
		});
		patient.parent && uids.push(patient.parent.uid);
		
		uids.forEach(uid => {
			dispatch({
				type: 'INSERT_SESSION_USER',
				payload: {
					'user': uid,
					'sessionId': sessionId
				}
			})
		})
	}

	sessionClick(session) {
		let { dispatch, videos } = this.props;
		let { sessionCommentText, patient_sessions_array } = this.state;
		if (!session) return
		dispatch({
			type: types.INSERT_SESSIONS,
			payload: patient_sessions_array[session.patientRecord]
		});
		this.setState({ 'sessionCommentText': '' });
		// add the therapist to the session users
		this.insertSessionUsers(session._id)

		dispatch(setModal('AdminPatientSession', null, {
			sessionId: session._id,
			videos: videos,
			removeImage: this.removeSessionImageFromSent,
			removeInternalImage: this.removeSessionInternalImageFromSent,
			commentText: sessionCommentText,
			updateCommentText: this.updateCommentText,
			activeVideoId: null,
			// addComment: this.addSessionComment,
			setActiveVideo: this.setActiveVideo,
			toggleVideoDone: this.toggleVideoDone,
			addComment: true
		}, true, 'fullscreen'))
	}

	handleSessionFormChange(e, key) {
		console.log(key)
		let val = e.target.value
		let data = { ...this.props.modal.data };
		data.session[key] = val;
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
	}



	deleteSession(sessionId) {
		const { User, dispatch } = this.props;
		if (confirm('Really delete this session?')) {
			dispatch(deleteSession(User._id, sessionId)).then(r => {
				this.setSessionsArray()
			})
		}
	}

	attachSessionImage(img) {
		let data = { ...this.props.modal.data };

		data.session.images = data.session.images || [];
		data.session.images.push(img);
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(false, false)
	}
	attachSessionInternalImage(img) {
		let data = { ...this.props.modal.data };

		data.session.internal_images = data.session.internal_images || [];
		data.session.internal_images.push(img);
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(false, false)
	}

	removeSessionImage(img) {
		let data = { ...this.props.modal.data };
		console.log('data', data);
		data.session.images = data.session.images || [];
		data.session.images = data.session.images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(data.session.sent)
	}

	removeSessionInternalImage(img) {
		let data = { ...this.props.modal.data };
		console.log('data', data);
		data.session.internal_images = data.session.internal_images || [];
		data.session.internal_images = data.session.internal_images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(data.session.sent)
	}

	removeSessionImageFromSent(img) {
		let data = { ...this.props.modal.data };
		let { sessions } = this.props;
		// from the sent popup there is a sessionId prop, not a session object
		data.session = sessions[data.sessionId]
		data.session.images = data.session.images || [];
		data.session.images = data.session.images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('TherapistSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(true, false)
	}

	removeSessionInternalImageFromSent(img) {
		debugger
		let data = { ...this.props.modal.data };
		let { sessions } = this.props;
		// from the sent popup there is a sessionId prop, not a session object
		data.session = sessions[data.sessionId]
		data.session.internal_images = data.session.internal_images || [];
		data.session.internal_images = data.session.internal_images.filter(i => {
			return i.orig !== img.orig
		})
		this.props.dispatch(setModal('TherapistSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
		this.saveSession(true, false)
	}

	setUpNewSession() {
		this.setState({
			//newSession: {...cleanNewSession, assessment_areas: this.latestAssessment().assessment_areas}
			'newSession': { ...cleanNewSession, therapy_areas: [] }
		})
	}

	saveSession(sent = false, clear = true) {
		let { patientRecord } = this.state;
		let s = {
			...this.props.modal.data.session,
			patient: patientRecord.patient,
			therapist: patientRecord.therapist,
			practice: patientRecord.practice,
			patientRecord: patientRecord._id,
			sent: sent
		}
		if (sent) {
			s.dateSent = new Date()
		}

		this.props.dispatch(saveSession(s))
			.then((r) => {
				this.setSessionsArray()
				this.getPatientRecord()
				console.log('saved session', clear);
				if (!clear) {
					let module = sent ? 'TherapistSession' : 'NewSession';
					let data = { ...this.props.modal.data };
					data.session._id = r.payload._id;
					this.props.dispatch(setModal(module, null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
				}
			})
		this.toggle('newSessionFormOpen', false)
		// eslint-disable-next-line
		clear && this.clearSession()

	}

	sendSession() {
		this.saveSession(true)
	}

	clearSession() {
		this.setState({
			'newSession': { ...cleanNewSession, therapy_areas: [] }
		})
	}


	setSessionsArray() {
		const { sessions } = this.props;
		let { patient_sessions_array } = this.state;
		let session = {};
		let sessions_array = [];

		for (const key in sessions) {
			if (sessions.hasOwnProperty(key)) {
				session = sessions[key];
			}
		}
		//sort
		sessions_array = Object.values(sessions).sort((a, b) => {
			if (a._id < b._id) {
				return 1;
			}
			if (a._id > b._id) {
				return -1;
			}
			// ... must be equal
			return 0;
		});
		patient_sessions_array[session.patientRecord] = sessions_array;
		this.setState({
			'patient_sessions_array': patient_sessions_array
		})
	}

	setAssessmentArray() {
		const { assessments } = this.props;
		let { patient_assessments_array } = this.state; 
		let assessment = {};
		
		for (const key in assessments) {
			if (assessments.hasOwnProperty(key)) {
				assessment = assessments[key];
			}
		}
		patient_assessments_array[assessment.patientRecord._id] = assessments;
		this.setState({
			'patient_assessments_array': patient_assessments_array
		});
		// console.log(this.state.patient_assessments_array);
	}

	setPractice() {
		if (this.props.User.therapistPractices) {
			let practice = this.props.User.therapistPractices.find(p => p._id === this.props.params.practiceId);
			if (practice) {
				this.props.dispatch(setPractice(practice))
			}
		}
	}

	assignAssessmentTherapyArea(area) {
		//this.assignTherapyArea('newAssessment', area)
		this.setState({
			'newAssessment': this.assignTherapyArea('newAssessment', area)
		})
	}

	assignSessionTherapyArea(area) {
		let { session } = this.props.modal.data;
		let areaId = area._id;
		let data = {};
		let therapy_areas;

		if (session.therapy_areas.indexOf(areaId) === -1) {
			// it's not here, add it
			therapy_areas = session.therapy_areas.concat([areaId])
		} else {
			// it's here, remove it
			therapy_areas = session.therapy_areas.filter(i => i !== areaId)
		}
		let selected_areas = this.sessionSelectedTherapyArea(therapy_areas)
		let selected_areas_videos = this.sessionSelectedTherapyAreaVideos(therapy_areas)
		data = {
			...this.props.modal.data,
			selected_areas: selected_areas,
			selected_areas_videos: selected_areas_videos,
			session: {
				...this.props.modal.data.session,
				therapy_areas: therapy_areas
			}
		}
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
	}

	sessionSelectedTherapyArea(areas) {
		let { therapy_areas } = this.props;
		return areas.map(areaId => therapy_areas[areaId] || {})
	}

	sessionSelectedTherapyAreaVideos(areas) {
		let { therapy_areas } = this.props;

		return [...new Set(areas.map(areaId => {
			return therapy_areas[areaId] ? therapy_areas[areaId].videos : []
		})
			.reduce((a, b) => a.concat(b), []))]
	}

	toggleSelectedSessionVideo(video) {
		let { session } = this.props.modal.data;
		let videoId = video;
		let data = {};
		let videos;
		if (session.videos.indexOf(videoId) === -1) {
			// it's not here, add it
			videos = session.videos.concat([videoId])
		} else {
			// it's here, remove it
			videos = session.videos.filter(i => i !== videoId)
		}
		data = {
			...this.props.modal.data,
			session: {
				...this.props.modal.data.session,
				videos: videos
			}
		}
		this.props.dispatch(setModal('NewSession', null, { ...this.props.modal.data, ...data }, true, 'fullscreen'))
	}

	assignTherapyArea(obj, area) {
		let areaId = area._id;
		let stateObj = this.state[obj];
		if (stateObj.therapy_areas.indexOf(areaId) === -1) {
			// it's not here, add it
			return { ...stateObj, therapy_areas: stateObj.therapy_areas.concat([areaId]) }
		} else {
			// it's here, remove it
			return { ...stateObj, therapy_areas: stateObj.therapy_areas.filter(i => i !== areaId) }
		}
	}

	savePatient(patient = this.state.patientForm) {
		this.props.dispatch(savePatient(this.props.User._id, this.props.app.practice._id, patient))
	}

	handlePatientInputChange(e, att) {
		this.setState({
			'patientForm': { ...this.state.patientForm, [att]: e.target.value }
		})
	}

	handlePatientImage(img) {
		this.setState({
			'patientForm': { ...this.state.patientForm, picture: img }
		})
		this.imageTimeout = setTimeout(() => {
			this.setState({
				'update': Math.random()
			})
		}, 5000)
	}

	getPatient() {
		let patient = this.props.patients.find(p => p._id === this.props.params.patientId);
		this.props.dispatch(setTitle(``))
		if (!this.state.gotPatients && !patient) {
			// get patients
			this.props.dispatch(fetchTherapistPatients(this.props.User._id))
				.then(() => {
					patient = this.props.patients.find(p => p._id === this.props.params.patientId);
					// this.props.dispatch(setTitle(`${patient.firstName || ''} ${patient.lastName || ''}`))
					this.setState({
						'patient': patient,
						'patientForm': patient,
						'gotPatients': true
					});
				})
		} else {
			// this.props.dispatch(setTitle(`${patient.firstName || ''} ${patient.lastName || ''}`))
			this.setState({
				'patient': patient,
				'patientForm': patient,
				'startDate': moment(patient.dob),
			});
		}
	}

	deletePatient() {
		let { patient } = this.state;
		console.log('Delete Patient');
		console.log(patient);
	}

	archivePatient() {
		let { patient } = this.state;
		let patientUpdate = patient;
		// console.log('Archive Patient');
		// console.log(patient);
		if (patient.archived) {
			// console.log('Unarchive');
			this.props.dispatch(unarchiveTherapistPatient(this.props.User._id, patient._id))
				.then(() => {
					patientUpdate = this.props.patients.find(p => p._id === this.props.params.patientId);
					this.setState({
						'patient': patientUpdate,
						'patientForm': patientUpdate,
						'gotPatients': true
					});
				});
		} else {
			// console.log('Archive');
			// get patients
			this.props.dispatch(archiveTherapistPatient(this.props.User._id, patient._id))
				.then(() => {
					patientUpdate = this.props.patients.find(p => p._id === this.props.params.patientId);
					this.setState({
						'patient': patientUpdate,
						'patientForm': patientUpdate,
						'gotPatients': true
					});
				})
		}
	}

	toggle(key, val) {
		this.setState({
			[key]: typeof val === 'undefined' ? !this.state[key] : val
		})
	}

	addAssessmentDocument(doc, assessment) {
		const { User, app } = this.props;
		const { newAssessment, patient, patientRecord } = this.state;
		const thisAssessment = assessment || newAssessment;
		this.props.dispatch(createAssessment(User._id,
			{
				...thisAssessment,
				patient: patient._id,
				practice: app.practice._id,
				therapist: User._id,
				patientRecord: patientRecord._id,
				documents: [...thisAssessment.documents, doc]
			}))
			.then(r => {
				console.log('setting new assessment')
				// eslint-disable-next-line
				assessment || this.setState({ 'newAssessment': r })
				//this.setup()
			});
	}

	toggleNewSessionAssessmentMenu() {
		this.setState({
			newSessionAssessmentMenu: !this.state.newSessionAssessmentMenu
		});
	}

	showMenu() {
		const {
			newSession,
			patient,
			newSessionAssessmentMenu,
			patient_sessions_array,
			patient_assessments_array
		} = this.state;
		// console.log(patient_sessions_array);
		// console.log(patient_assessments_array);
		// console.log(patient);
		// console.log(patient.parent);
		if (typeof patient !== 'undefined') {
			// console.log(patient);
			return (<div className="row patientDetailsView patientMenu marginless">
				<div className="page-menu  row fill ">
					<div className="">
						{/*<div className="fixedButton">
							<div className="md-button-fab patientButtonNew dark add" onClick={() => this.toggleNewSessionAssessmentMenu()}>+</div>
							<div className={newSessionAssessmentMenu ? "menu show" : "menu"}>
								<a onClick={() => {
									this.clearSession();
									this.showNewSessionForm(newSession);
									this.toggleNewSessionAssessmentMenu();
								}}>New Session</a>
								<a onClick={() => {
									this.setState({ 'newAssessment': cleanNewAssessment });
									this.toggle('newAssessmentFormOpen');
									this.toggleNewSessionAssessmentMenu();
								}}>New Assesment</a>
							</div>
						</div>*/}
					</div>
					<div className="patientPhoto">
						{patient.picture && <Avatar pic={`${patient.picture.thumb}`} />}
					</div>
					<div className="patientInfo">
						<p>{patient.firstName} {patient.lastName}</p>
						<small>{(patient.parent) && patient.parent.name}</small>
						<small>Date of birth: {moment(patient.dob).format('YYYY/MM/DD')}</small>
					</div>
					<div className="patientButtons">
						<div className="buttons">
							{/*<a onClick={() => this.toggle("editPatientOpen")} >EDIT PATIENT</a>*/}
							{/*
								(
									((patient.guardians !== undefined) && (patient.guardians.length > 0)) || 
									((patient.therapists !== undefined) && (patient.therapists.length > 0)) ||
									((patient.therapy_areas !== undefined) && (patient.therapy_areas.length > 0)) ||
									 (patient.parent !== null) || (patient_sessions_array.length > 0) ||
									 (patient_assessments_array.length > 0)
								) ?
									(patient.archived) ?
										// This should be set to unarchived 
										<a onClick={() => this.archivePatient()} >
											<img className="unArchiveSVG" src={unArchiveSVG} />
										</a> :
										// This should be set to archived 
										<a onClick={() => this.archivePatient()} >
											<img className="archiveSVG" src={archiveSVG} />
										</a> :
									<a onClick={() => this.deletePatient()} >
										<img src={deleteSVG} />
									</a>
							*/}
						</div>
					</div>
					{/* <div>
						<MoreVerticalSVG click={this.refs.rightNav ? this.refs.rightNav.openMenu : null} />
					</div> */}

				</div>
				{/* <div className="filterCard">
					<select name="selectType" id="selectType">
						<option value="all">All</option>
						<option value="session">Session</option>
						<option value="assesment">Assesment</option>
					</select>
				</div> */}
			</div>
			)
		}
	}

	showNewAssessmentForm() {
		let { newAssessment, patient } = this.state;
		return this.state.newAssessmentFormOpen ? <div>
			<AssessmentForm
				close={() => this.toggle("newAssessmentFormOpen")}
				assessment={newAssessment}
				handleFormChange={this.handleAssessmentFormChange}
				addDocument={this.addAssessmentDocument}
				deleteDocument={this.deleteAssessmentDocument}
				patient={patient}
				assignTherapyArea={this.assignAssessmentTherapyArea}
				assessmentStartDate={this.state.assessmentStartDate}
				handleDOAChange={this.handleAssessmentDOAChange}
				save={() => this.createAssessment(this.state.newAssessment)} />
		</div> : null;
	}

	showNewSessionForm(session) {
		let { patient, newSessionSelectTherapyAreasOpen, newSessionSelectVideosOpen, patientRecord } = this.state;
		let { videos, therapy_areas, dispatch } = this.props;

		if (session._id) {
			this.setState({ 'whichSession': 'store' })
		} else {
			this.setState({ 'whichSession': 'state' })
		}
		dispatch(setModal('NewSession', null, {
			therapy_areas: therapy_areas,
			patient: patient,
			attachImage: this.attachSessionImage,
			removeImage: this.removeSessionImage,
			attachInternalImage: this.attachSessionInternalImage,
			removeInternalImage: this.removeSessionInternalImage,
			patientRecord: patientRecord,
			toggleSessionAreasOpen: this.toggle,
			handleSessionFormChange: this.handleSessionFormChange,
			assignSessionTherapyArea: this.assignSessionTherapyArea,
			saveSession: this.saveSession,
			sendSession: this.sendSession,
			handleToggleSelectedSessionVideo: this.toggleSelectedSessionVideo,
			session: session,
			selected_areas: this.sessionSelectedTherapyArea(session.therapy_areas),
			selected_areas_videos: this.sessionSelectedTherapyAreaVideos(session.therapy_areas),
			videos: videos,
			newSessionSelectVideosOpen: newSessionSelectVideosOpen,
			newSessionSelectTherapyAreasOpen: newSessionSelectTherapyAreasOpen
		}, true, 'fullscreen'))
	}

	assessmentCategoryClick(category) {
		this.toggle('active_category', category)
	}


	showLatestAssessmentDetails() {
		let { therapy_areas, therapy_categories, User } = this.props;
		let { patient, active_category } = this.state;

		if (!therapy_areas) return []


		const assessment = this.latestAssessment();
		const categoryAreas = () => assessment.therapy_areas
			.filter(areaId => {
				if (!therapy_areas[areaId]) return []
				return therapy_areas[areaId] ? therapy_areas[areaId].categories.indexOf(active_category) !== -1 : false
			}
			).map(areaId => therapy_areas[areaId])
		const age = () => {
			if (patient.dob && assessment) {
				let assessmentDate = assessment.doa || assessment.modified
				let duration = moment.duration(moment(assessmentDate).diff(patient.dob))
				return duration.years() + ' years ' + duration.months() + ' months'
			} else {
				return ''
			}
		}

		let interalNotes = '';
		if (User.therapist) {
			interalNotes = <span id="internalNotesOpenAssesment"><h4>Internal Notes</h4><p>{this.latestAssessment().internal_notes}</p></span>
		}

		if (assessment) {


			return <div className="card wide assessment marginless">
				<div className="card-header">
					<a className="link right" onClick={() => this.toggle("showAssessment")}>Close</a>Latest Assessment
				</div>

				<div className="card-content">
					<table className="data" >
						<tr>
							<th width="30%">Date</th>
							<td>{assessment.doa ? moment(assessment.doa).format('ddd Do of MMM YYYY') : moment(assessment.modified).format('ddd Do of MMM YYYY')}</td>
						</tr>
						<tr>
							<th width="30%">Age</th>
							<td>{age()}</td>
						</tr>
					</table>
					<h4>Parent Notes</h4>
					<p>{this.latestAssessment().description}</p>
					{interalNotes}

				</div>
				<div className="card-content">
					<div className="md-body1">Therapy areas</div>
					<ShowCategories
						active_category={active_category}
						click={this.assessmentCategoryClick}
						therapy_areas={this.latestAssessment().therapy_areas.map(areaId => therapy_areas[areaId])}
						therapy_categories={therapy_categories}
					/>
					<CategoryAreas active_category={active_category} therapy_areas={categoryAreas()} />

				</div>

				<div className="card-content">
					<div className="md-body1">
						Documents
						</div>
					{assessment.documents.length ? assessment.documents.map(doc => {

						return <p key={`doc-${doc.name}`}>
							<a className="link right" onClick={() => this.deleteAssessmentDocument(doc)}><small>Delete</small></a>
							<FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
						</p>
					}) : null}

				</div>
				<div>
					<div className="right">
						{/*<DocumentUpload update={true} callback={d => this.addAssessmentDocument(d, assessment)} path={`documents/assessments/patients/${patient._id}/`} />*/}
						
					</div>
				</div>
			</div>
		} else {
			return null
		}
	}

	showEditSession(session) {
		this.showNewSessionForm(session)
	}

	latestAssessment() {
		let { assessments } = this.props;
		let { patientId } = this.props.params;
		if (assessments && Object.keys(assessments).length) {
			// get this patient record's assessments
			let this_assessments = Object.values(assessments)
				.filter(r => r.patient === patientId);
			// get the keys and sort them desc
			let this_assessments_keys = this_assessments
				.map(a => a._id)
				.slice(0)
				.sort((a, b) => {
					return a < b ? 1 : -1
				});
			// return the highest _id assessment
			let latestId = this_assessments_keys[0]

			return assessments[latestId];
		} else {
			return null
		}
	}

	toggleShowAssessment(assessment) {
		this.setState({
			showAssessment: true,
			currenetAssessment: assessment
		})
	}

	showAssessment() {
		let { therapy_areas, therapy_categories, User } = this.props;
		let { patient, active_category, currenetAssessment } = this.state;

		if (!therapy_areas) return []
		const categoryAreas = () => currenetAssessment.therapy_areas
			.filter(areaId => {
				if (!therapy_areas[areaId]) return []
				return therapy_areas[areaId] ? therapy_areas[areaId].categories.indexOf(active_category) !== -1 : false
			}
			).map(areaId => therapy_areas[areaId])
		const age = () => {
			if (patient.dob && currenetAssessment) {
				let assessmentDate = currenetAssessment.doa || currenetAssessment.modified
				let duration = moment.duration(moment(assessmentDate).diff(patient.dob))
				return duration.years() + ' years ' + duration.months() + ' months'
			} else {
				return ''
			}
		}

		let interalNotes = '';
		if (User.therapist) {
			interalNotes = <span><h4>Internal Notes</h4><p>{currenetAssessment.internal_notes}</p></span>
		}

		if (currenetAssessment) {

			return <div id="assesmentFormScroll" className="assesmentFormScroll patientViewDashboard"><div className="card assessmentView">
				<div className="card-header">
					<div className="headerText">Assessment</div>
					<a className="link" onClick={() => this.toggle("showAssessment")}>&times;</a>
				</div>

				<div className="card-content">
					<table className="data" >
						<tr>
							<th width="30%">Date of Assessment</th>
							<td>{currenetAssessment.doa ? moment(currenetAssessment.doa).format('ddd Do of MMM YYYY') : moment(currenetAssessment.modified).format('ddd Do of MMM YYYY')}</td>
						</tr>
						<tr>
							<th width="30%">Age</th>
							<td>{age()}</td>
						</tr>
					</table>
					<span>
						<h4>Parent Notes</h4>
						<p>{currenetAssessment.description}</p>
					</span>
					{interalNotes}

				</div>
				<div className="card-content">
					<div className="md-body1">Therapy areas</div>
					<ShowCategories
						active_category={active_category}
						click={this.assessmentCategoryClick}
						therapy_areas={currenetAssessment.therapy_areas.map(areaId => therapy_areas[areaId])}
						therapy_categories={therapy_categories}
					/>
					<CategoryAreas active_category={active_category} therapy_areas={categoryAreas()} />

				</div>

				<div className="card-content">
					<div className="md-body1">
						Documents
						</div>
					{currenetAssessment.documents.length ? currenetAssessment.documents.map(doc => {

						return <p key={`doc-${doc.name}`}>
							<a className="link right" onClick={() => this.deleteAssessmentDocument(doc)}><small>Delete</small></a>
							<FileImg /><a href={`${doc.url}`} target="_new">{doc.name}</a>
						</p>
					}) : null}

				</div>
				<div>
					<div className="right">
						{/*<DocumentUpload update={true} callback={d => this.addAssessmentDocument(d, currenetAssessment)} path={`documents/assessments/patients/${patient._id}/`} />*/}
						
					</div>
				</div>
			</div>
			</div>
		} else {
			return null
		}
	}

	fetchMoreSessions() {
		const { from, patientRecord } = this.state;
		const { dispatch } = this.props
		if (!patientRecord._id) return
		// this.setState({ 'loading': true })

		dispatch(fetchSessions(patientRecord._id, from + 1))
			.then(sessions => {
				this.setSessionsArray()
				if (!sessions.length) {
					this.setState({ 'noMoreSessions': true })
				}
				this.setState({ 'loading': false, 'from': from + 1 })
			})
	}

	blur(val) {
		this.setState({
			'blur': val
		})
	}


	_renderWaypoint() {
		const { loading, noMoreSessions } = this.state;
		if (noMoreSessions) {
			return <div><p><br />No more sessions</p> </div>
		}
		return (
			loading ? <div>Loading ... </div> : <Waypoint
				onEnter={this.fetchMoreSessions}
			/>
		)
	}

	filterBy(event) {
		this.setState({
			filterBy: event.target.value
		});
	}

	filterByDate(date) {
		this.setState({
			filterDate: date
		});
	}

	toggleHomework(id) {
		let homework = (this.state.homework === id) ? null : id;
		this.setState({
			homework: homework
		});
	}

	getAssessmentsSessionsArray() {
		let {
			patient_sessions_array,
			patient_assessments_array,
			filterBy,
			filterDate
		} = this.state;
		let assessmentsSessionsArray = [];

		if (filterBy === 'all' || filterBy === 'assessments') {
			// console.log('Assessments');
			for (var key in patient_assessments_array) {
				if (patient_assessments_array.hasOwnProperty(key)) {
					let patient_assessments_object = patient_assessments_array[key];
					for (const key in patient_assessments_object) {
						if (patient_assessments_object.hasOwnProperty(key)) {
							const assessment = patient_assessments_object[key];
							const tempDate = (assessment.doa !== null) ? assessment.doa : assessment.modified;
							if (moment(tempDate) >= filterDate) {
								assessmentsSessionsArray.push({
									'type': 'assessment',
									'date': tempDate,
									'data': assessment
								});
							}
						}
					}
				}
			}
		}

		if (filterBy === 'all' || filterBy === 'sessions') {
			// console.log('Sessions');
			// console.log(patient_sessions_array);
			for (var key in patient_sessions_array) {
				if (patient_sessions_array.hasOwnProperty(key)) {
					let patient_sessions = patient_sessions_array[key];
					patient_sessions.forEach(function (value, index) {
						if (moment(value.created) >= filterDate) {
							assessmentsSessionsArray.push({
								'type': 'session',
								'date': value.created,
								'data': value
							});
						}
					});
				}
			}
			patient_sessions_array.forEach(function (patient_sessions, key) {
				if (patient_sessions.length) {
					
				}
			});
		}
		// console.log(assessmentsSessionsArray);
		assessmentsSessionsArray.sort(function (a, b) {
			return new Date(b.date) - new Date(a.date);
		});

		// console.log(assessmentsSessionsArray);

		return assessmentsSessionsArray;
	}

	render() {
		let {
			blur,
			patientForm,
			showAssessment,
			patientRecord,
			newAssessmentFormOpen,
			editPatientOpen,
			update,
			startDate,
			filterBy,
			filterDate,
			homework,
			loading
		} = this.state;
		let { notifications, videos, therapy_categories, User } = this.props;

		if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

		return (
			<div>
				<Sidenav ref="rightNav" User={User.User} callback={this.blur} className="right" onLogout={this.logout} >
					<div>
						<div className="side-nav__content">
							<br /><br /><br />
							<div className="padding">
								{this.isEditable() ? (
									<div className="fill link row" onClick={() => {
										this.setState({ 'newAssessment': cleanNewAssessment })
										this.toggle('newAssessmentFormOpen'); this.refs.rightNav.closeMenu()
									}}>
										<div className={"md-button-fab dark add open-close  " + (!newAssessmentFormOpen && 'close')}>+</div>
										<div className="fill padding ">Assessment</div>
									</div>) : null}
							</div>
							<ul>
								<li>
									<a className="link " onClick={() => { this.toggle("showAssessment"); this.refs.rightNav.closeMenu() }}>Last assessment</a>
								</li>
								{this.isEditable() ? (
									<li>
										<a className="link " onClick={() => { this.toggle('editPatientOpen'); this.refs.rightNav.closeMenu() }}>Edit Patient</a>
									</li>) : null}
							</ul>
						</div>
					</div>
				</Sidenav>
				<main className={"main " + (blur ? ' blur' : '')}>
					{this.showMenu()}
					<br />
					<div className="padding">
						{showAssessment && <div>{this.showAssessment()}<br /></div>}
						{this.showNewAssessmentForm()}

						{editPatientOpen && <div className="editPatientCard">
							<div className="card  marginless">
								<div className="card-header">
									<div className="cardHeaderText">
										Edit patient
									</div>
									<a className="link" onClick={() => this.toggle("editPatientOpen")}>&times;</a>
								</div>
								<div>
									<PatientDetailsForm
										update={update}
										handlePatientImage={this.handlePatientImage}
										handleInputChange={this.handlePatientInputChange}
										hide={{ firstName: true, lastName: true, middleName: true }}
										patient={patientForm}
										startDate={startDate}
										handleChange={(date) => {

											this.handleChange(date)
										}}
										handleSubmit={() => {
											this.savePatient(patientForm);
											this.toggle('editPatientOpen');
										}
										} />
								</div>
							</div>
						</div>
						}

						<div className=" ">
							{patientRecord.length && <AssessmentComponent
								{...this.props}
								isEditable={this.isEditable()}
								patient_sessions_array={this.getAssessmentsSessionsArray()}
								handleEdit={this.showEditSession}
								handleDelete={this.deleteSession}
								toggleShowAssessment={this.toggleShowAssessment}
								therapy_categories={therapy_categories}
								patient={patientForm}
								notifications={notifications.sessions}
								videos={videos}
								openClick={this.sessionClick}
								patientRecord={patientRecord}
								filterBy={this.filterBy}
								filter={filterBy}
								filterDate={filterDate}
								filterByDate={this.filterByDate}
								homework={homework}
								toggleHomework={this.toggleHomework}>
							</AssessmentComponent>}
						</div>

						<div><p><br />No more Assessments or Sessions</p> </div>
					</div>
				</main>
			</div>
		)
	}
}

export default withRouter(PatientViewDashboard);



// WEBPACK FOOTER //
// ./src/components/practice_admin/patient/PatientViewDashboard.jsx